// src/utils/formatNumber.ts
export function formatMoney(
  n?: number | null,
  currency = "$",
  opts: { minDp?: number; maxDp?: number } = {}
) {
  if (typeof n !== "number" || Number.isNaN(n)) return "—";
  const { minDp = 2, maxDp = 2 } = opts;

  // The sign leads the currency symbol (-$45.50, never $-45.50), and it is
  // decided from what actually gets DISPLAYED, not from the raw input's sign.
  // Relocating the sign without that check would turn $-0.00 into -$0.00,
  // which is exactly as wrong. So the magnitude is formatted first and
  // compared against zero formatted at the same precision: when they render
  // identically the value is zero on screen and takes no sign, covering -0
  // and anything that rounds away (-0.001 at 2dp, -0.4 at 0dp). Asking
  // toLocaleString itself, rather than reproducing its rounding with
  // arithmetic, means the two can never disagree. "∞" never matches "0.00",
  // so -Infinity keeps its sign.
  const dpOpts = {
    minimumFractionDigits: minDp,
    maximumFractionDigits: maxDp,
  };
  const body = Math.abs(n).toLocaleString(undefined, dpOpts);
  const zeroBody = (0).toLocaleString(undefined, dpOpts);
  const sign = n < 0 && body !== zeroBody ? "-" : "";

  return `${sign}${currency}${body}`;
}

export function formatNumber(
  n?: number | null,
  opts: { minDp?: number; maxDp?: number } = {}
) {
  if (typeof n !== "number" || Number.isNaN(n)) return "—";
  const { minDp = 0, maxDp = 2 } = opts;
  return n.toLocaleString(undefined, {
    minimumFractionDigits: minDp,
    maximumFractionDigits: maxDp,
  });
}

export function formatQty(n?: number | null) {
  return formatNumber(n, { minDp: 0, maxDp: 2 });
}

export function formatPercent(n?: number | null, dp = 2) {
  if (typeof n !== "number" || Number.isNaN(n)) return "—";
  return `${formatNumber(n, { minDp: 0, maxDp: dp })}%`;
}
